var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loading__wrapper', { 'loading--absolute' : _vm.absolute }]},[_c('SVGacem-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }